














































import {
  Component, Vue,
} from 'vue-property-decorator';

import LayoutContent from '@/components/LayoutContent.vue';
import Checkbox from '@/components/Checkbox.vue';

import ChevronIcon from 'mdi-vue/ChevronRight';
import api from '@/libs/api';

@Component({
  components: {
    LayoutContent,
    Checkbox,
    ChevronIcon,
  },
})

export default class ExternalBillingList extends Vue {
  /* eslint-disable */
  mounted() {
    // console.log('route', this.$route.params);
    try {
      this.urlMonthlyId = parseInt(this.$route.params.recon_id);
    } catch (err) {

    }
    this.loadData();
  }

  urlMonthlyId: number = 0;

  selectAll = false;

  billingList: any = [
    // {
    //   service_name: 'Mandiri Bill Payment',
    //   brand_name: 'Citilink',
    //   expanded: false,
    //   checked: false,
    //   merchant_traffic: [
    //     { periode: 'January 2021', checked: false },
    //     { periode: 'February 2021', checked: false },
    //     { periode: 'March 2021', checked: false },
    //     { periode: 'April 2021', checked: false },
    //   ],
    // },
    // {
    //   service_name: 'BCA VA',
    //   brand_name: 'Citilink',
    //   expanded: false,
    //   checked: false,
    //   merchant_traffic: [
    //     { periode: 'February 2021', checked: false },
    //     { periode: 'March 2021', checked: false },
    //     { periode: 'April 2021', checked: false },
    //   ],
    // },
  ]

  async loadData() {
    // const { data } = await api.get(`recon/traffic/merchant/M5a7286048eda6`)
    const { data } = await api.get(`recon/external/services`)
    // M5a7286048eda6 unipin (mdr)
    // M5f351c72a6547/5EC37DDD62052/202105 prismalink (mix)
    // M5701ca121364e citilink (normal)
    if (data.status === true) {
      this.billingList = data.data.service_list;
      // console.log('billing', this.billingList);
      // this.billingList = this.billingList.filter((data: any) => data.merchant_traffic.length > 0)
      //   .filter((data: any) => data.bill_type == 'Normal'); // hanya menampilkan yang bill type normal
      Object.values(this.billingList).forEach((data: any) => {
        Vue.set(data, 'expanded', false);
        Vue.set(data, 'checked', false);
        data.services.forEach((val: any) => {
          if (val.id.toString() === this.$route.params.recon_id) {
            Vue.set(data, 'expanded', true);
            const a = parseInt(this.$route.params.recon_id);
            this.selectPeriod(a);
          } else {
          }
        })
      });
      // console.log('billingList', this.billingList);
    }
  }

  selectPeriod(monthlyTrafficId: number) {
    try {
      let selectedPeriod: any[] = [];
      Object.values(this.billingList).forEach((data: any) => {
        let selected = data.services.filter((val: any) => val.id === monthlyTrafficId);
        // .map((val: any) => { return { credential_code: val.credential_code, periode_slug: val.periode_slug } });
        if (selected.length > 0) {
          let parent = {
            ...data,
            // merchant_code: data.merchant_code,
            // service: data.service,
            // service_name: data.service_name,
            // brand_name: data.brand_name,
            // price_per_transaction: data.price_per_transaction,
            // total_traffic_service,
            // total_billing_service,
            merchant_traffic: selected,
          }
          selectedPeriod.push(parent);
        }
      });
      this.$emit('selectPeriod', selectedPeriod);
    } catch (error) {
      console.log(error);
    }
  }
}
